import PANE from '../../../../../APP/page/pane/PANE.js';
import { text } from '../../../../../DOM/text/TEXT.js';
import { heading } from '../../../../../DOM/heading/HEADING.js';
import { hr } from '../../../../../DOM/hr/HR.js';
export default class PANE_Home_Conduct extends PANE {
    constructor(node, model) {
        super(node, model);
        this.addClass('full-frame');
        this.addClass('code-of-conduct');
        this.addHeading(heading(1, 'Code of Conduct'));
        this.addHeading(heading(2, 'Policies and Practices'));
        this.addP(text('A summary of ClaimSecure\'s policies and practices regarding user conduct:'));
        this.addHR(hr());
        let endpoint = 'core/messagebus/version';
        this.logInfo('Initial Endpoint', endpoint);
        // TODO: Create a Table of Contents for different sections
    }
}
